"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderWrapper = exports.HeaderItem = exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _classnames = _interopRequireDefault(require("classnames"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _animate = require("../../utils/animate");

var _ArrowForwardIos = _interopRequireDefault(require("@material-ui/icons/ArrowForwardIos"));

var _ArrowBackIos = _interopRequireDefault(require("@material-ui/icons/ArrowBackIos"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Header = function Header(_ref) {
  var title = _ref.title,
      actions = _ref.actions;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pr-5 mb-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "ml-8 text-2xl font-semibold text-dark overflow-hidden"
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, actions)));
};

Header.defaultProps = {
  actions: []
};
var _default = Header;
exports["default"] = _default;
var HeaderItem = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var name = _ref2.name,
      unread = _ref2.unread,
      onClick = _ref2.onClick,
      _ref2$invert = _ref2.invert,
      invert = _ref2$invert === void 0 ? false : _ref2$invert,
      _ref2$isActive = _ref2.isActive,
      isActive = _ref2$isActive === void 0 ? true : _ref2$isActive,
      _ref2$isDragOver = _ref2.isDragOver,
      isDragOver = _ref2$isDragOver === void 0 ? false : _ref2$isDragOver;
  var clickAvaliable = !(0, _isNil["default"])(onClick);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    className: (0, _classnames["default"])('mr-3 select-none whitespace-no-wrap px-3 text-dark', {
      'bg-gray-light dark:bg-secondary rounded !text-white': isDragOver && !invert,
      'opacity-50 hover:opacity-100': !isActive && !isDragOver,
      'cursor-pointer': clickAvaliable
    }),
    onClick: clickAvaliable ? onClick : null
  }, name, !(0, _isNil["default"])(unread) && unread > 0 ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-lg ml-1"
  }, "(", unread.toLocaleString(), ")") : '');
});
exports.HeaderItem = HeaderItem;

function ScrollButton(_ref3) {
  var invert = _ref3.invert,
      children = _ref3.children,
      props = (0, _objectWithoutProperties2["default"])(_ref3, ["invert", "children"]);
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, props, {
    className: "flex px-2 text-gray-light hover:text-dark"
  }), children);
}

var HeaderWrapper = function HeaderWrapper(_ref4) {
  var _ref4$invert = _ref4.invert,
      invert = _ref4$invert === void 0 ? false : _ref4$invert,
      children = _ref4.children,
      suffix = _ref4.suffix;
  var ref = (0, _react.useRef)(null);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)({
    start: false,
    end: false
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      displayScroll = _useState2[0],
      setDisplayScroll = _useState2[1];

  (0, _react.useEffect)(function () {
    Promise.resolve().then(handleOnScroll);

    if (ref.current) {
      window.addEventListener('resize', handleOnScroll);
      return function () {
        window.removeEventListener('resize', handleOnScroll);
      };
    }
  }, [!!ref.current, children]);

  function handleOnScroll() {
    var listRef = ref.current;

    if (listRef) {
      var clientWidth = listRef.clientWidth,
          scrollLeft = listRef.scrollLeft,
          scrollWidth = listRef.scrollWidth;
      var nextDisplayScroll = {
        start: scrollLeft > 1,
        end: scrollLeft < scrollWidth - clientWidth - 1
      };

      if (nextDisplayScroll.start !== displayScroll.start || nextDisplayScroll.end !== displayScroll.end) {
        setDisplayScroll(_objectSpread({}, nextDisplayScroll));
      }
    }
  }

  var scrollButton = (0, _react.useMemo)(function () {
    var start = /*#__PURE__*/_react["default"].createElement(ScrollButton, {
      invert: invert,
      onClick: onPrevious,
      title: t('button.previous')
    }, /*#__PURE__*/_react["default"].createElement(_ArrowBackIos["default"], {
      fontSize: "small"
    }));

    var end = /*#__PURE__*/_react["default"].createElement(ScrollButton, {
      invert: invert,
      onClick: onNext,
      title: t('button.next')
    }, /*#__PURE__*/_react["default"].createElement(_ArrowForwardIos["default"], {
      fontSize: "small"
    }));

    return {
      start: displayScroll.start && start,
      end: displayScroll.end && end
    };
  }, [displayScroll, invert]);

  function scrollTo(to) {
    var element = ref.current;

    if (element) {
      (0, _animate.animate)(element, 'scrollLeft', to);
    }
  }

  function onPrevious(e) {
    e.stopPropagation();
    var listRef = ref.current;

    if (listRef) {
      var scrollLeft = listRef.scrollLeft;

      var _children = Array.from(listRef.children);

      var totalWidth = 0;

      for (var i = 0; i < _children.length; i++) {
        var node = _children[i];

        if (totalWidth + node.clientWidth >= scrollLeft) {
          scrollTo(totalWidth);
          break;
        }

        totalWidth += node.clientWidth;
      }
    }
  }

  function onNext(e) {
    e.stopPropagation();
    var listRef = ref.current;

    if (listRef) {
      var clientWidth = listRef.clientWidth,
          scrollLeft = listRef.scrollLeft;

      var _children2 = Array.from(listRef.children);

      var totalWidth = 0;

      for (var i = 0; i < _children2.length; i++) {
        totalWidth += _children2[i].clientWidth;

        if (totalWidth > clientWidth + scrollLeft) {
          // When the previous button is not shown
          // Need count it's width
          scrollTo(totalWidth - clientWidth + (displayScroll.start ? 0 : 40));
          break;
        }
      }
    }
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, scrollButton.start, /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref,
    onScroll: handleOnScroll,
    className: "flex items-center overflow-x-auto scrollbar-hidden"
  }, _react["default"].Children.map(children, function (node) {
    return /*#__PURE__*/_react["default"].createElement("div", null, node);
  })), scrollButton.end, suffix && /*#__PURE__*/_react["default"].createElement("div", null, suffix));
};

exports.HeaderWrapper = HeaderWrapper;
//# sourceMappingURL=index.js.map